export default __webpack_public_path__ + "static/media/l_barwani210222054458_706_H@@IGHT_0_W@@IDTH_600.3fcb1178.jpg";